import { type IBannerEnrichments } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';
import { type TAdfoxBannerCompleteSizes } from 'shared/types/adfox';
import { type TTgbStretchContext } from 'shared/types/bannerContext';

import { type TTgbStretchProps } from '../../TgbStretch';

type TGetTgbStretchPropsParams = {
  context: TTgbStretchContext;
  sizes: TAdfoxBannerCompleteSizes;
  bannerEnrichment: null | IBannerEnrichments;
};

export function getTgbStretchProps({
  context: {
    url,
    label,
    title,
    description,
    note,
    logoImageUrl,
    button,
    bgImageUrl,
    mortgageTermsWarning,
    mortgageWarning,
  },
  sizes,
  bannerEnrichment,
}: TGetTgbStretchPropsParams): TTgbStretchProps {
  const props: TTgbStretchProps = {
    annotation: note,
    button,
    description,
    image: bgImageUrl,
    label,
    logoUrl: logoImageUrl,
    mortgageTermsWarning,
    mortgageWarning,
    sizes,
    title,
    url,
  };

  if (bannerEnrichment) {
    Object.assign<TTgbStretchProps, Partial<TTgbStretchProps>>(props, {
      logoUrl: bannerEnrichment.publisher.logo.url,
    });
  }

  return props;
}
